module.exports = __webpack_public_path__ + "img/lucy.b505b72.webp";